// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入vuex配置
import store from './store'
// router的配置
import './permission'
// 全局引入工具类
import Utils from '@/utils/utils.js'
// ajax
import request from '@/utils/request'
// 全局常量
import Constant from '@/api/constant.js'
// 全局css样式
// import '@/components/common/common.css'

Vue.config.productionTip = false

import bus from '@/utils/bus.js'
Vue.prototype.$bus = bus;

// 引入element-ui插件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)




Vue.prototype.$utils = Utils
Vue.prototype.$axios = request
Vue.prototype.$constant = Constant
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js